<template>

  <article class="c-article__logos c-slider">
    <transition :name="currentTransition" mode="out-in">
      <div :key="activeSlide" ref="slider" class="c-slider__list js-slider" v-if="desktopSlider">
        <div class="o-layout o-layout--stretch" :class="content.images.length < logosPerSlide ? 'o-layout--large' : ''">
          <div class="o-layout__item" :class="content.images.length < logosPerSlide ? `u-1/${content.images.length}` : `u-1/${logosPerSlide}`" v-for="(item, index) in content.images.slice((activeSlide) * logosPerSlide, (activeSlide + 1) * logosPerSlide)" :key="index">
            <div class="c-article__logo-wrapper">
              <img :slider="true" class="c-article__logo" :src="item.url" alt="">
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="c-slider__list js-slider" ref="slider" v-if="mobileSlider">
      <div class="scrolling-wrapper">
        <div class="c-article__logo-wrapper" :class="`u-1/${logosPerSlide}`" v-for="(item, index) in content.images" :key="index">
          <img :slider="true" class="c-article__logo" :src="item.url" alt="">
        </div>
      </div>
    </div>

    <div class="c-slider__controls" v-if="content.slider == 'manualSlider' && content.images.length > logosPerSlide && desktopSlider">
      <div class="c-slider__control" data-control="prev" @click.prevent="goToSlide('prev')" @keyup.left="arrowSlider()">
        <span></span>
      </div>
      <div class="c-slider__pagination">
        <span class="c-slider__current-slide">{{ activeSlide + 1 }}</span>
        <span>/</span>
        <span class="c-slider__all-sides">{{ slideCount }}</span>
      </div>
      <div class="c-slider__control" @click.prevent="goToSlide('next')" @keyup.right="arrowSlider()">
        <span></span>
      </div>
    </div>
  </article>

</template>

<script>
export default {
  name: 'Logos',
  props: ['content'],

  data () {
    return {
      sliderTransition: true,
      currentTransition: null,
      desktopSlider: false,
      mobileSlider: false,
      logosPerSlide: 5,
      activeSlide: 0,
      slides: this.content.images,
      slideCount: Math.floor(this.content.images.length / 5),
      windowWidth: 0,
      isInView: false,
      slideInterval: null,
      transitionTimeout: null
    }
  },

  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  mounted () {
    window.addEventListener('resize', this.loopSlider)
    this.loopSlider()

    window.addEventListener('scroll', this.enableKeyboardControls)
    this.enableKeyboardControls()

    document.addEventListener('keyup', this.arrowSlider)
  },

  methods: {
    goToSlide (dir) {
      if (this.content.slider == 'manualSlider' || this.arrowSlider == true) {
        this.currentTransition = dir

        if (dir === 'prev') {
          if (this.activeSlide === 0) {
            this.activeSlide = this.slideCount - 1
          } else this.activeSlide--
        } else {
          if (this.activeSlide === (this.slideCount - 1)) {
            this.activeSlide = 0
          } else this.activeSlide++
        }
      }
    },

    loopSlider () {
      if (this.desktopSlider == true && this.content.slider == 'automaticSlider' && this.slides.length > this.logosPerSlide) {
        this.currentTransition = 'fade'
        clearInterval(this.slideInterval)
        this.slideInterval = setInterval(function () {
          if (this.activeSlide < this.slideCount - 1) {
            this.activeSlide++
          } else {
            this.activeSlide = 0
          }
        }.bind(this), 5000)
      } else if (this.mobileSlider == true) {
        clearInterval(this.slideInterval)
        this.activeSlide = 0
      }
    },

    handleResize () {
      this.windowWidth = window.innerWidth

      if (this.windowWidth <= 480) {
        this.logosPerSlide = 3
        this.desktopSlider = false
        this.mobileSlider = true
      } else if (this.windowWidth > 480 && this.windowWidth <= 769) {
        this.logosPerSlide = 4
        this.slideCount = Math.ceil(this.content.images.length / 4)
        this.desktopSlider = true
        this.mobileSlider = false
        console.log(this.slideCount, this.content.images.length);
      } else {
        this.logosPerSlide = 5
        this.slideCount = Math.ceil(this.content.images.length / 5)
        if (this.activeSlide >= this.slideCount) {
          this.goToSlide('prev')
        }
        this.desktopSlider = true
        this.mobileSlider = false
        console.log(this.slideCount, this.content.images.length);
      }
    },

    isInViewport (elem) {
      var bounding = elem.getBoundingClientRect()
      return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    },

    enableKeyboardControls () {
        this.isInView = this.isInViewport(this.$el)
    },

    arrowSlider (dir) {
      if (!this.isInView) {
        return
      }
      if (this.desktopSlider == true && this.content.slider == 'automaticSlider') {
        clearInterval(this.slideInterval)
      }
      if (dir.key == 'ArrowRight') {
        this.goToSlide('next')
      } else if (dir.key == 'ArrowLeft') {
        this.goToSlide('prev')
      }
    }
  }
}
</script>
